/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationWithEdrBlacklisted
 */
export interface OrganizationWithEdrBlacklisted {
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithEdrBlacklisted
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationWithEdrBlacklisted
     */
    organizationName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationWithEdrBlacklisted
     */
    blacklistedDomains: Array<string>;
}

/**
 * Check if a given object implements the OrganizationWithEdrBlacklisted interface.
 */
export function instanceOfOrganizationWithEdrBlacklisted(value: object): value is OrganizationWithEdrBlacklisted {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('blacklistedDomains' in value) || value['blacklistedDomains'] === undefined) return false;
    return true;
}

export function OrganizationWithEdrBlacklistedFromJSON(json: any): OrganizationWithEdrBlacklisted {
    return OrganizationWithEdrBlacklistedFromJSONTyped(json, false);
}

export function OrganizationWithEdrBlacklistedFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationWithEdrBlacklisted {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'organizationName': json['organizationName'],
        'blacklistedDomains': json['blacklistedDomains'],
    };
}

export function OrganizationWithEdrBlacklistedToJSON(value?: OrganizationWithEdrBlacklisted | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'blacklistedDomains': value['blacklistedDomains'],
    };
}

